import React, { useState, useEffect } from 'react';
import { 
  collection, 
  onSnapshot, 
  doc, 
  deleteDoc, 
  query, 
  orderBy 
} from 'firebase/firestore';
import { FaTrash, FaEdit, FaSearch, FaBoxOpen } from 'react-icons/fa';
import './ProductList.css';
import { db } from '../firebase/firebase-config';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Ürünleri gerçek zamanlı dinliyoruz kanka
    const q = query(collection(db, "products"), orderBy("createdAt", "desc"));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const productData = snapshot.docs.map(doc => ({
        // Firestore'un kendi atadığı doküman ID'sini alıyoruz (Silme için bu şart!)
        docId: doc.id, 
        ...doc.data()
      }));
      setProducts(productData);
      setLoading(false);
    }, (error) => {
      console.error("Veri çekme hatası:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleDelete = async (docId, name) => {
    // Silme onayı alalım kanka
    const confirmDelete = window.confirm(`${name} isimli eseri koleksiyondan tamamen silmek istediğine emin misin?`);
    
    if (confirmDelete) {
      try {
        // Firestore'daki gerçek doküman ID'sini kullanarak siliyoruz
        await deleteDoc(doc(db, "products", docId));
        alert("Eser başarıyla silindi kral.");
      } catch (error) {
        console.error("Silme işlemi başarısız:", error);
        alert("Silerken bir hata oluştu, konsola bak kanka.");
      }
    }
  };

  // Arama filtresi
  const filteredProducts = products.filter(p => 
    p.name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
    p.id?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="admin-loader">Eserler yükleniyor...</div>;

  return (
    <div className="product-list-wrapper">
      <div className="list-controls">
        <div className="admin-search">
          <FaSearch />
          <input 
            type="text" 
            placeholder="Ürün adı veya Lot No ara..." 
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="product-count">
          <FaBoxOpen /> <span>{products.length} Kayıtlı Eser</span>
        </div>
      </div>

      <div className="admin-table-container">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Görsel</th>
              <th>Lot No</th>
              <th>Eser Adı</th>
              <th>Kategori</th>
              <th>Boyut</th>
              <th>Fiyat</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((p) => (
              <tr key={p.docId}>
                <td>
                  <img src={p.img} alt={p.name} className="admin-table-img" />
                </td>
                <td><span className="lot-badge">#{p.id}</span></td>
                <td><strong className="product-name-cell">{p.name}</strong></td>
                <td><span className="cat-tag">{p.cat}</span></td>
                <td><span className="size-tag">{p.size}</span></td>
                <td className="price-cell">{p.price}</td>
                <td className="actions-cell">
                  {/* Düzenleme kısmı şu an pasif, sonra yaparız kanka */}
                  <button className="edit-btn" title="Düzenle">
                    <FaEdit />
                  </button>
                  <button 
                    className="delete-btn" 
                    title="Sil" 
                    onClick={() => handleDelete(p.docId, p.name)}
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {filteredProducts.length === 0 && (
          <div className="empty-list">
            Kriterlere uygun ürün bulunamadı kral.
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductList;